import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { TextField, Autocomplete, MenuItem } from '@mui/material';
import {
    updateQcRange,
    createQcRange,
    getQcRangeDataById
} from '../../../../services/clinicPortalServices/qcRangeService.js';
import { getAllAnalytes } from '../../../../services/clinicPortalServices/analyteService.js';
import { getUserFullName } from '../../../../services/common/util.js';
import toastr from 'toastr';
import { qcControlTypes } from '../../../../services/common/optionsData.js';

export default class QcRangeDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qcRangeId: this.props && this.props.qcRangeId ? this.props.qcRangeId : '',
            analyteId: this.props && this.props.analyteId ? this.props.analyteId : '',
            controlType: '',
            controlTypes: [],
            resultType: 'Numeric',
            targetValue: '',
            sdValue: '',
            targetValues: [],
            sdValues: [],
            resultChoices: [],
            validValues: [],
            errors: [],
            analytes: []
        };
    }

    componentDidMount() {
        if (this.state.qcRangeId) {
            this.loadDetails();
        }
        getAllAnalytes().then((res) => {
            if (res && res.data) {
                this.setState({ analytes: res.data });
            }
        });
    }

    loadDetails = () => {
        getQcRangeDataById(this.state.qcRangeId).then((res) => {
            const qcRangeInfo = res.data;
            this.setState({
                analyteId: qcRangeInfo.analyteId,
                controlType: qcRangeInfo.controlType,
                resultType: qcRangeInfo.resultType,
                targetValue: qcRangeInfo.targetValue,
                sdValue: qcRangeInfo.sdValue,
                resultChoices: qcRangeInfo.resultChoices,
                validValues: qcRangeInfo.validValues
            });
        });
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    addArrayItem = (type) => {
        let updateValues = this.state[type];
        updateValues.push('');
        this.setState({
            [type]: updateValues
        });
    };

    updateArrayItem = (value, index, type) => {
        let updateValues = this.state[type];
        this.setState({
            [type]: updateValues.map((item, i) => {
                if (i === index) {
                    item = value;
                }
                return item;
            })
        });
    };

    removeArrayItem = (index, type) => {
        let updateValues = this.state[type];
        updateValues.splice(index, 1);
        this.setState({
            [type]: updateValues
        });
    };

    saveChanges = () => {
        let errors = [];
        if (!this.state.analyteId) {
            errors.push('analyteId');
        }
        if (!this.state.controlType && !this.state.controlTypes) {
            errors.push('controlType');
        }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }

        if (this.state.qcRangeId) {
            let qcRangeInfo = {
                analyteId: this.state.analyteId,
                controlType: this.state.controlType,
                resultType: this.state.resultType,
                targetValue: this.state.targetValue,
                sdValue: this.state.sdValue,
                resultChoices: this.state.resultChoices,
                validValues: this.state.validValues,
                _id: this.state.qcRangeId
            };
            updateQcRange(qcRangeInfo).then((res) => {
                this.props.handleClose();
                if (this.props.context && this.props.context.componentParent) {
                    this.props.context.componentParent.loadGridData();
                }
            });
        } else {
            window.responseNumber = 0;
            this.state.controlTypes.map((controlType, index) => {
                let qcRangeInfo = {
                    analyteId: this.state.analyteId,
                    controlType: controlType,
                    resultType: this.state.resultType,
                    targetValue: this.state.targetValues[index],
                    sdValue: this.state.sdValues[index],
                    resultChoices: this.state.resultChoices,
                    validValues: this.state.validValues,
                    createdBy: getUserFullName()
                };
                createQcRange(qcRangeInfo).then((res) => {
                    window.responseNumber++;
                    if (window.responseNumber === this.state.controlTypes.length) {
                        this.props.handleClose();
                        if (this.props.context && this.props.context.componentParent) {
                            this.props.context.componentParent.loadGridData();
                        }
                        toastr.success('QC Range created successfully');
                    }
                });
                return null;
            });
        }
    };

    render() {
        let allowedControlTypes = qcControlTypes;
        if (this.props.controlTypes) {
            allowedControlTypes = this.props.controlTypes;
        }
        let existingQcRanges = [];
        if (
            this.props.context.componentParent &&
            this.props.context.componentParent.state &&
            this.props.context.componentParent.state.rowData
        ) {
            existingQcRanges = this.props.context.componentParent.state.rowData;
        }
        return (
            <div>
                <div className="row form-row">
                    <div className="col-12">
                        <div className="form-group">
                            <Autocomplete
                                value={this.state.analyteId}
                                options={this.state.analytes
                                    .filter((anlayteItem) => {
                                        if (existingQcRanges && existingQcRanges.length) {
                                            let existingQcRangeCountForAnalyte = existingQcRanges.filter(
                                                (item) => item.analyteId._id === anlayteItem._id
                                            ).length;
                                            if (existingQcRangeCountForAnalyte === allowedControlTypes.length) {
                                                return false;
                                            } else {
                                                return true;
                                            }
                                        } else {
                                            return true;
                                        }
                                    })
                                    .map((item) => item._id)}
                                disabled={this.props.analyteId || this.props.qcRangeId ? true : false}
                                getOptionLabel={(option) =>
                                    option && this.state.analytes.length > 0
                                        ? this.state.analytes.find((item) => item._id === option).name
                                        : ''
                                }
                                onChange={(event, newValue) => {
                                    this.handleChange({
                                        target: {
                                            value: newValue,
                                            name: 'analyteId'
                                        }
                                    });
                                    this.setState({
                                        controlTypes: []
                                    });
                                }}
                                renderInput={(params) => <TextField {...params} label="Analyte *" variant="outlined" />}
                            />
                            <div className={this.hasError('analyteId') ? 'inline-errormsg' : 'hidden'}>
                                <i className="fa fa-exclamation-circle" aria-hidden="true">
                                    &nbsp;This field is required.
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <Autocomplete
                                multiple={this.state.qcRangeId ? false : true}
                                value={this.state.qcRangeId ? this.state.controlType : this.state.controlTypes}
                                filterSelectedOptions
                                disableCloseOnSelect
                                disabled={this.state.qcRangeId || !this.state.analyteId ? true : false}
                                options={allowedControlTypes.filter(
                                    (type) =>
                                        !existingQcRanges.find(
                                            (existingItem) =>
                                                existingItem.analyteId._id === this.state.analyteId &&
                                                existingItem.controlType === type
                                        )
                                )}
                                onChange={(event, newValue) => {
                                    if (this.state.qcRangeId) {
                                        this.setState({
                                            controlType: newValue
                                        });
                                    } else {
                                        if (this.state.controlTypes.length > newValue.length) {
                                            let index = null;
                                            this.state.controlTypes.map((item, i) => {
                                                if (!newValue.includes(item)) {
                                                    index = i;
                                                }
                                                return null;
                                            });
                                            this.removeArrayItem(index, 'targetValues');
                                            this.removeArrayItem(index, 'sdValues');
                                        } else {
                                            this.addArrayItem('targetValues');
                                            this.addArrayItem('sdValues');
                                        }
                                        this.setState({
                                            controlTypes: newValue
                                        });
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={this.state.qcRangeId ? 'Control Type *' : 'Control Types *'}
                                        variant="outlined"
                                    />
                                )}
                            />
                            <div className={this.hasError('controlType') ? 'inline-errormsg' : 'hidden'}>
                                <i className="fa fa-exclamation-circle" aria-hidden="true">
                                    &nbsp;This field is required.
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                label="Result Type"
                                select
                                name="resultType"
                                value={this.state.resultType}
                                onChange={this.handleChange}
                            >
                                <MenuItem value="Numeric">Numeric</MenuItem>
                                <MenuItem value="Qualitative">Qualitative</MenuItem>
                            </TextField>
                        </div>
                    </div>
                    {this.state.resultType === 'Numeric' &&
                        !this.state.qcRangeId &&
                        this.state.controlTypes.map((controlType, index) => {
                            let numericDoms = [];
                            numericDoms.push(
                                <div className="col-12">
                                    <div className="form-group">
                                        <TextField
                                            label={'Target Value (' + controlType + ')'}
                                            name={'targetValues' + index}
                                            value={this.state.targetValues[index]}
                                            onChange={(e) => {
                                                this.updateArrayItem(e.target.value, index, 'targetValues');
                                            }}
                                            type="number"
                                        />
                                    </div>
                                </div>
                            );
                            numericDoms.push(
                                <div className="col-12">
                                    <div className="form-group">
                                        <TextField
                                            label={'Standard Deviation From Target Value (' + controlType + ')'}
                                            name={'sdValues' + index}
                                            value={this.state.sdValues[index]}
                                            onChange={(e) => {
                                                this.updateArrayItem(e.target.value, index, 'sdValues');
                                            }}
                                            type="number"
                                        />
                                    </div>
                                </div>
                            );
                            return numericDoms;
                        })}
                    {this.state.resultType === 'Numeric' && this.state.qcRangeId && (
                        <div className="col-12">
                            <div className="form-group">
                                <TextField
                                    label="Target Value"
                                    name="targetValue"
                                    value={this.state.targetValue}
                                    onChange={this.handleChange}
                                    type="number"
                                />
                            </div>
                        </div>
                    )}
                    {this.state.resultType === 'Numeric' && this.state.qcRangeId && (
                        <div className="col-12">
                            <div className="form-group">
                                <TextField
                                    label="Standard Deviation From Target Value"
                                    name="sdValue"
                                    value={this.state.sdValue}
                                    onChange={this.handleChange}
                                    type="number"
                                />
                            </div>
                        </div>
                    )}
                    {this.state.resultType === 'Qualitative' && (
                        <div className="col-12 input-box mb-3">
                            <div className="form-group">
                                <label>
                                    Result Choices{' '}
                                    <i
                                        className="fa fa-plus-circle btn"
                                        onClick={() => this.addArrayItem('resultChoices')}
                                    ></i>
                                </label>
                                {this.state.resultChoices.map((resultChoice, index) => {
                                    return (
                                        <div className="d-flex align-items-center mt-2">
                                            <TextField
                                                key={index}
                                                value={resultChoice}
                                                onChange={(e) =>
                                                    this.updateArrayItem(e.target.value, index, 'resultChoices')
                                                }
                                            />
                                            <i
                                                className="fa fa-times-circle btn"
                                                onClick={() => this.removeArrayItem(index, 'resultChoices')}
                                            ></i>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {this.state.resultType === 'Qualitative' && (
                        <div className="col-12 input-box mb-3">
                            <div className="form-group">
                                <label>
                                    Valid Values{' '}
                                    <i
                                        className="fa fa-plus-circle btn"
                                        onClick={() => this.addArrayItem('validValues')}
                                    ></i>
                                </label>
                                {this.state.validValues.map((validValue, index) => {
                                    return (
                                        <div className="d-flex align-items-center mt-2">
                                            <TextField
                                                key={index}
                                                value={validValue}
                                                onChange={(e) =>
                                                    this.updateArrayItem(e.target.value, index, 'validValues')
                                                }
                                            />
                                            <i
                                                className="fa fa-times-circle btn"
                                                onClick={() => this.removeArrayItem(index, 'validValues')}
                                            ></i>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
                <div className="row">
                    <div
                        className="col-12"
                        style={{
                            paddingTop: '10px',
                            borderTop: '1px solid rgba(0,0,0,.2'
                        }}
                    >
                        <Button
                            style={{ float: 'right', marginLeft: '10px' }}
                            variant="primary"
                            onClick={this.saveChanges}
                        >
                            Save Changes
                        </Button>
                        <Button style={{ float: 'right' }} variant="secondary" onClick={this.props.handleClose}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
